export default class FluxoBancarioExtrato {
    
    constructor(model = null){
        this.id = 0;
        this.empresaId = 0;
        this.projetoId = 0;
        this.bancoId = 0;
        this.dataInicial = '';
        this.dataFinal = '';
        this.documento = '';

        if (!model)
            return;

        this.id = model.id ? model.id : 0;
        this.empresaId = model.empresaId;
        this.projetoId = model.projetoId;
        this.projeto = model.projeto;
        this.bancoId = model.bancoId;
        this.dataInicial = new Date(model.dataInicial).yyyymmdd();
        this.dataFinal = new Date(model.dataFinal).yyyymmdd();
        this.documento = model.documento;
    }
}